import React from 'react';
import { SelectItem } from '../../../components/ui/select';

// Options formateurs : le référent pédagogique de l'AF en tête, puis les autres.
export const FormateurOptions = ({ formateurs, referentId, currentId }) => {
  const visibles = formateurs.filter(f => f.sous_contrat !== false || f.id === currentId || f.id === referentId);
  const referent = visibles.find(f => f.id === referentId);
  const autres = visibles.filter(f => f.id !== referentId);
  return (
    <>
      <SelectItem value="none"><span className="text-slate-400">Aucun</span></SelectItem>
      {referent && (
        <SelectItem value={referent.id} className="font-semibold text-indigo-700" data-testid={`option-referent-${referent.id}`}>
          {referent.nom} {referent.prenom} — Référent
        </SelectItem>
      )}
      {autres.map(f => <SelectItem key={f.id} value={f.id}>{f.nom} {f.prenom}{f.statut_intervenant === 'externe' ? ' (ext.)' : ''}</SelectItem>)}
    </>
  );
};

// Options lieux : le lieu principal de l'AF en tête, puis les autres.
export const LieuOptions = ({ lieux, lieuPrincipal }) => {
  const principal = lieux.find(l => l.nom === lieuPrincipal);
  const autres = lieux.filter(l => l.nom !== lieuPrincipal);
  return (
    <>
      <SelectItem value="none"><span className="text-slate-400">Aucun</span></SelectItem>
      {principal && (
        <SelectItem value={principal.nom} className="font-semibold text-indigo-700" data-testid="option-lieu-principal">
          {principal.nom} — Lieu de l'AF
        </SelectItem>
      )}
      {autres.map(l => <SelectItem key={l.id} value={l.nom}>{l.nom}{l.ville ? ` — ${l.ville}` : ''}</SelectItem>)}
    </>
  );
};
